module.exports = __webpack_public_path__ + "f9c27f81aa2592f0abc2eebfa421eddf.jpg";